import { z } from "zod";

const translationPath = "page.4uMarCom.campaigns.errors.";

const typeSchema = z.object(
  {
    id: z.string(),
    name: z.string(),
    code: z.string().nullish(),
  },
  { invalid_type_error: translationPath + "type" }
);

export const registerCampaignSchema = z.object({
  id: z.string().optional(),
  enable: z.boolean(),
  name: z
    .string()
    .trim()
    .min(1, translationPath + "name"),
  description: z.string().nullish(),
  campaignType: typeSchema,
});

export type TRegisterCampaignForm = z.infer<typeof registerCampaignSchema>;
